import { render, staticRenderFns } from "./AboutUS.vue?vue&type=template&id=7177fdc9&scoped=true"
import script from "./AboutUS.vue?vue&type=script&lang=js"
export * from "./AboutUS.vue?vue&type=script&lang=js"
import style0 from "./AboutUS.vue?vue&type=style&index=0&id=7177fdc9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7177fdc9",
  null
  
)

export default component.exports